import { Loader2 } from 'lucide-react'

import { useRecommendationEngineMock } from './recommendation-engine-context'

/**
 * Shared "Recalculating…" banner shown while the mock store is running a
 * recalculation cascade. Renders nothing when idle. Used by every coach-facing
 * tab so an action's effect is visible on the tab where it originated.
 */
export function RecalculatingBanner() {
  const { recalculating } = useRecommendationEngineMock()
  if (!recalculating) return null
  return (
    <div className="flex items-center gap-2 rounded-lg border border-indigo-300 bg-indigo-50 p-3 dark:border-indigo-500/30 dark:bg-indigo-500/10">
      <Loader2
        size={16}
        className="animate-spin text-indigo-600 dark:text-indigo-400"
      />
      <p className="text-sm font-medium text-indigo-800 dark:text-indigo-300">
        Recalculating the knowledge map…
      </p>
    </div>
  )
}
